<div class="title-field--base title-field--spacingBottom-{{ spacingBottom }}">
  <div
    class="title--group"
    [ngClass]="{
      'title--group-of-2': backButton
    }"
  >
    <button
      class="title--button"
      *ngIf="backButton"
      (click)="onClick()"
      attr.data-test-id="{{ testIdPrefix }}-back-button"
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.537 17.2636C14.8885 17.615 14.8885 18.1849 14.5371 18.5364C14.1856 18.8879 13.6157 18.8879 13.2643 18.5364L7.26364 12.5364C6.91212 12.1849 6.91212 11.6151 7.26364 11.2636L13.2643 5.26357C13.6157 4.91212 14.1856 4.91215 14.5371 5.26364C14.8885 5.61513 14.8885 6.18498 14.537 6.53643L9.17286 11.9L14.537 17.2636Z"
          fill="#2F3133"
        />
      </svg>
    </button>
    <h2
      *ngIf="size < 3"
      class="title--title title--title-{{ size }}"
      attr.data-test-id="{{ testIdPrefix }}-title-heading"
    >
      {{ title }}
    </h2>
    <p
      *ngIf="size === 3"
      class="title--title title--title-{{ size }}"
      attr.data-test-id="{{ testIdPrefix }}-title-text"
    >
      {{ title }}
    </p>
  </div>
  <p
    *ngIf="secondaryText"
    class="title--secondary"
    attr.data-test-id="{{ testIdPrefix }}-secondary-text"
  >
    {{ secondaryText }}
  </p>
  <p
    *ngIf="subTitle"
    class="title--sub-title"
    attr.data-test-id="{{ testIdPrefix }}-subTitle-text"
  >
    {{ subTitle }}
  </p>
  <p
    *ngIf="body"
    class="title--body"
    attr.data-test-id="{{ testIdPrefix }}-body-text"
  >
    {{ body }}
  </p>
</div>
